<template>
  <ConfirmActionDialog
    :model-value="modelValue"
    :title="title"
    description="Confirm you understand that removing this account from the Involuntary PAYG journey will:"
    :bullet-points="[
      'The customer will no longer receive Involuntary PAYG notifications',
      'The customer will not be placed onto PAYG',
      'An alternative debt collection method should be used if appropriate',
    ]"
    confirm-title="Remove from Involuntary PAYG"
    test-id="remove-from-involuntary-payg"
    :loading="loading"
    @update:model-value="$emit('update:modelValue', $event)"
    @confirm="$emit('confirm')"
  />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import ConfirmActionDialog from "./ConfirmActionDialog.vue"

  export default defineComponent({
    components: {
      ConfirmActionDialog,
    },
    props: {
      modelValue: {
        type: Boolean,
        required: true,
      },
      accountNumber: {
        type: String,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue", "confirm"],
    computed: {
      title(): string {
        return `Remove Account ${this.accountNumber} from Involuntary PAYG journey`
      },
    },
  })
</script>
